import { Vessel, PartInstance, partById, childrenOf, subtreeOf } from '../core/vessel/vessel'

export interface Rottura {
  readonly remaining: Vessel
  readonly detached: Vessel
}

/**
 * Spezza il veicolo a un giunto.
 *
 * A differenza di un disaccoppiatore, qui non c'e niente di volontario: il
 * pezzo si stacca dove la struttura ha ceduto, e le coordinate locali restano
 * quelle di prima, cosi lo stato del corpo rigido si trasporta con la sola
 * correzione di baricentro.
 */
export function separaAlGiunto(vessel: Vessel, partId: string): Rottura | null {
  if (!vessel.parts.some((p) => p.id === partId)) return null
  const parte = partById(vessel, partId)
  if (parte.parentId === null) return null

  const staccate = subtreeOf(vessel, partId)
  const idStaccate = new Set(staccate.map((p) => p.id))

  return {
    remaining: { rootId: vessel.rootId, parts: vessel.parts.filter((p) => !idStaccate.has(p.id)) },
    detached: {
      rootId: partId,
      parts: staccate.map((p): PartInstance => (p.id === partId ? { ...p, parentId: null } : p)),
    },
  }
}
